import { createContext, useContext, useState, useMemo } from 'react';

const initialState = '';

export const ItemContext = createContext({
  activeKey: initialState,
  setActiveKey: () => {},
  clearActiveKey: () => {},
});

export const ItemContextProvider = ({ children }) => {
  const [activeKey, setActiveKey] = useState(initialState);
  const value = useMemo(
    () => ({
      activeKey,
      setActiveKey,
      clearActiveKey: () => setActiveKey(initialState),
    }),
    [activeKey],
  );

  return <ItemContext.Provider value={value}>{children}</ItemContext.Provider>;
};

export const useItemContext = () => useContext(ItemContext);
